import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import JsBarcode from 'jsbarcode';
import { createCanvas } from 'canvas';

const generateBarcodeImageDataURL = (barcodeValue) => {
    const canvas = document.createElement('canvas');
    JsBarcode(canvas, barcodeValue, {
        format: 'CODE128',
        width: 2,
        height: 50,
        displayValue: true, // Show the barcode number below
        fontSize: 14,       // Optional: adjust font size
        margin: 10,         // Optional: add margin above/below
      });
    return canvas.toDataURL('image/png'); // returns base64 data URI
};

const base64ToArrayBuffer = (dataURL) => {
    const base64 = dataURL.split(',')[1];
    const binary = atob(base64);
    const len = binary.length;
    const buffer = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        buffer[i] = binary.charCodeAt(i);
    }
    return buffer;
};

const generateBarcode = (internalId) => {
    return '227' + internalId.toString().padStart(9, '0');
};

export const exportToExcel = async (models, thumbnails) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('CallTimes');

    // Define columns
    worksheet.columns = [
        { header: 'Barcode', key: 'barcode', width: 33 },
        { header: 'Image', key: 'image', width: 15 },
        { header: 'ID', key: 'id', width: 10 },
        { header: 'Name', key: 'name', width: 20 },
        { header: 'Date', key: 'date', width: 12 },
        { header: 'Calltime', key: 'calltime', width: 9 },
        { header: 'Agency / Booker / Phone', key: 'agency', width: 80 },
        { header: 'Location', key: 'location', width: 75 },
        { header: 'Studio', key: 'studio', width: 25 },
        { header: 'Client', key: 'client', width: 40 }
    ];

    // Add rows (no images yet)
    models.forEach((model, i) => {
        worksheet.addRow({
            barcode: "",
            image: "",
            id: model.internalId,
            name: model.firstName,
            date: new Date().toLocaleDateString('de-DE'),
            calltime: '8:00',
            agency: model.agencies?.[0] || 'No Agency',
            location: 'Orendt Studios ALTONA, Behringstraße 28a, 22765 Hamburg',
            studio: 'Orendt Studio Altona',
            client: 's.Oliver Bernd Freier GmbH & Co. KG'
        });

        const barcodeValue = generateBarcode(model.internalId);
        const barcodeDataUrl = generateBarcodeImageDataURL(barcodeValue);
        const barcodeBuffer = base64ToArrayBuffer(barcodeDataUrl);

        const barcodeImageId = workbook.addImage({
            buffer: barcodeBuffer,
            extension: 'png',
        });

        worksheet.addImage(barcodeImageId, {
            tl: { col: 0, row: i + 1 },
            ext: { width: 200, height: 100 },
        });

        // Embed image
        fetch(thumbnails[i].file)
            .then(res => res.blob())
            .then(async (blob) => {
                const arrayBuffer = await blob.arrayBuffer();
                const imageId = workbook.addImage({
                    buffer: arrayBuffer,
                    extension: 'png', // or 'jpeg'
                });

                worksheet.addImage(imageId, {
                    tl: { col: 1, row: i + 1 }, // top-left of image cell
                    ext: { width: 100, height: 100 },
                });

                // Save after last image has loaded
                if (i === models.length - 1) {
                    const buffer = await workbook.xlsx.writeBuffer();
                    saveAs(new Blob([buffer]), 'CallTimes_With_Images.xlsx');
                }
            });
    });

    worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 1) {
            row.height = 100; // Adjust height as needed for image or multiline text
        } else {
            row.height = 20; // Adjust height as needed for image or multiline text
        }
    });
    worksheet.columns.forEach(col => {
        col.alignment = { horizontal: 'middle', wrapText: true };
    });
};
